var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 3,
    stroke: "#1E1E1E",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.188 11.4343C20.5762 11.9056 20.7703 12.1412 20.7703 12.5C20.7703 12.8588 20.5762 13.0944 20.188 13.5657C18.7679 15.2899 15.6357 18.5 12 18.5C8.36427 18.5 5.23206 15.2899 3.81197 13.5657C3.42381 13.0944 3.22973 12.8588 3.22973 12.5C3.22973 12.1412 3.42381 11.9056 3.81197 11.4343C5.23206 9.71014 8.36427 6.5 12 6.5C15.6357 6.5 18.7679 9.71014 20.188 11.4343Z",
    stroke: "#1E1E1E",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye_open.db52ef026fe3536ecf7d01327944b178.svg";
export { ForwardRef as ReactComponent };